import React from "react";
import "./styles.css";
import {useTranslation} from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import matrix from "../../../../assets/img/matrix.png";
import computers from "../../../../assets/img/computers.png";
import mob from "../../../../assets/img/mob.png";
import help from "../../../../assets/img/help.png";
import blog from "../../../../assets/img/blog.png";

export default () => {
    const [t] = useTranslation("common")
    return (
        <div className="descriptionSectionItem">
            <div className="splendosMatrix" id={"splendosGrid"}>
                <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                    <h1>
                        {t("home.mainFeatures.splendosMatrix.title")}
                    </h1>
                    <p>{t("home.mainFeatures.splendosMatrix.description")}</p>
                    <div className="buttonsContent">
                        <CustomButton keyTranslate={"common.learnMore"} />
                    </div>
                </div>
                <img className="wow fadeInUp" data-wow-delay="0.8s" src={matrix} alt={"matrix"}/>
            </div>

            <div className="computers">
                <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                    <h1>
                        {t("home.mainFeatures.computers.title")}
                    </h1>
                    <p>{t("home.mainFeatures.computers.description")}</p>
                    <div className="buttonsContent">
                        <CustomButton keyTranslate={"common.learnMore"} />
                    </div>
                </div>
                <img className="wow fadeInUp" data-wow-delay="0.8s" src={computers} alt={"computers"}/>
            </div>

            <div className="splendosMobile" id={"splendosMobile"}>
                <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                    <h1>
                        {t("home.mainFeatures.splendosMobile.title")}
                    </h1>
                    <p>{t("home.mainFeatures.splendosMobile.description")}</p>
                    <div className="buttonsContent">
                        <CustomButton keyTranslate={"common.learnMore"} />
                        <CustomButton keyTranslate={"common.download"} />
                    </div>
                </div>
                <img className="wow fadeInUp" data-wow-delay="0.8s" src={mob} alt={"mob"}/>
            </div>

            <div className="horizontalSection">
                <div className="verticalSection" id={"blog"}>
                    <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                        <h1>
                            {t("home.mainFeatures.help.title")}
                        </h1>
                        <p>{t("home.mainFeatures.help.description")}</p>
                        <div className="buttonsContent">
                            <CustomButton keyTranslate={"common.visitHelp"} />
                        </div>
                    </div>
                    <img className="wow fadeInUp" data-wow-delay="0.8s" src={help} alt={"help"}/>
                </div>
                <div className="verticalSection" id={"help"}>
                    <div className="titleContent wow fadeInUp" data-wow-delay="0.6s">
                        <h1>
                            {t("home.mainFeatures.blog.title")}
                        </h1>
                        <p>{t("home.mainFeatures.blog.description")}</p>
                        <div className="buttonsContent">
                            <CustomButton keyTranslate={"common.visitBlog"} />
                        </div>
                    </div>
                    <img className="wow fadeInUp" data-wow-delay="0.8s" src={blog} alt={"blog"}/>
                </div>
            </div>
        </div>
    );
};
